import { ConversationSummary, MessageView } from '../core/hub-types';

/** A burst of messages chimes once. */
const QUIET_AFTER_CHIME_MS = 1500;

export interface ChimeInput {
  conversation: ConversationSummary | undefined;
  message: MessageView;
  /** this user's principal id on the hub */
  me: string | null;
  now: number;
  /** the conversation is open in the chat window, and the page is in front of the user */
  viewing: boolean;
  /** the "message sounds" setting on this device */
  soundsOn: boolean;
  lastChimeAt: number;
}

/**
 * Whether a message someone else sent should chime: sounds on here, a conversation you are in (not one you only look
 * into), not muted, its notify setting lets it through (nothing; only @-mentions of you; everything), you are not
 * already looking at it, and not straight after another chime.
 */
export function shouldChime({ conversation: c, message, me, now, viewing, soundsOn, lastChimeAt }: ChimeInput): boolean {
  if (!soundsOn || viewing || !c || c.access !== 'participant') return false;
  if (c.mutedUntil && Date.parse(c.mutedUntil) > now) return false;
  const level = c.notifyLevel ?? 'all';
  if (level === 'none') return false;
  if (level === 'mentions' && !(me && message.mentions?.principals?.includes(me))) return false;
  return now - lastChimeAt >= QUIET_AFTER_CHIME_MS;
}
